
import { defineComponent, ref } from 'vue';
import CouponDetail from '@/components/organisms/coupon/CouponDetail.vue';
import CouponDescription from '@/components/organisms/coupon/content/CouponDescription.vue';
import CouponAvailableShops from '@/components/organisms/coupon/content/CouponAvailableShops.vue';
import { useCoupon } from '@/compositions/useCoupon';
import { useRoute, useRouter } from 'vue-router/composables';

/**
 * クーポン詳細ダイアログ
 */
export default defineComponent({
  name: 'DialogCouponDetail',

  components: {
    CouponDetail,
    CouponDescription,
    CouponAvailableShops,
  },

  setup() {
    const { getDetail, outOfStock, getRestrictionSettingLabel, getTerm, withinTerm: _withinTerm } = useCoupon();
    const route = useRoute();
    const couponId = route.params.id;
    const dialog = ref<boolean>(false);

    const coupon = ref<any /* coupon */>();
    const restriction = ref<string>('');
    const hasTerm = ref<boolean>(false);
    const withinTerm = ref<boolean>(false);

    // useAsync
    const router = useRouter();
    (async () => {
      try {
        coupon.value = await getDetail(couponId, 'STORE');
      } catch (e) {
        await router.replace('/error');
      }

      const restrictionSettings = coupon.value.restrictionSettings;
      restriction.value = getRestrictionSettingLabel(restrictionSettings);

      const term = getTerm(coupon.value);
      hasTerm.value = term != null;
      withinTerm.value = _withinTerm(coupon.value);
    })();

    return {
      coupon,
      restriction,
      hasTerm,
      withinTerm,
      dialog,

      outOfStock,
    };
  },
});
